import { saveAs } from 'file-saver'

import { getPushResultsCsv } from '_services/api-integrations'

// "afs-brands-yahoo-results-failed-2026-10-08.csv" - the taxonomy, the
// partner, the results filter if one is set, and the day the push started
export const resultsCsvName = (push, state) =>
  `${[
    push.taxonomy?.slug || 'no-taxonomy',
    push.partner,
    'results',
    state,
    push.started_at && new Date(push.started_at).toISOString().slice(0, 10),
  ]
    .filter(Boolean)
    .join('-')}.csv`

// A push's results as a CSV file - every row, or only those in `state`. Used
// by the push's page and by the lists of pushes, so the file is the same
// wherever it is downloaded from.
export const downloadResults = async (push, state) => {
  const csv = await getPushResultsCsv(push._id, { state })
  saveAs(new Blob([csv], { type: 'text/csv;charset=utf-8;' }), resultsCsvName(push, state))
}
